module.exports = __webpack_public_path__ + "img/toniguyroundtrans.b8fd49a6.png";